import { defineBreadcrumb, useSchemaOrg } from '#imports';

export function useBreadcrumbSchema(items: Array<{ name: string; item?: string }>) {
  useSchemaOrg([
    defineBreadcrumb({
      itemListElement: items,
    }),
  ]);
}
